import React from "react";
import { Plus, Users, Building2, TrendingUp, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { requiresActivation } from "../constants/plans";
import { NAV_LABELS } from "../constants/uiCopy";

const QuickActionsMenu = ({ user }) => {
  const navigate = useNavigate();

  const getActions = () => {
    const role = user?.role;
    if (requiresActivation(user)) {
      return [];
    }

    if (role === "basic") {
      return [
        {
          icon: Building2,
          label: "Explorar Desarrollos",
          color: "bg-stone-900",
          action: () => navigate("/developments-list"),
        },
      ];
    }

    if (role === "owner") {
      return [
        {
          icon: Plus,
          label: "Nueva Propiedad",
          color: "bg-primary",
          action: () => navigate("/add-property"),
        },
      ];
    }

    if (role === "broker") {
      return [
        {
          icon: Plus,
          label: "Nueva Propiedad",
          color: "bg-primary",
          action: () => navigate("/add-property"),
        },
        {
          icon: Users,
          label: "Nuevo Lead",
          color: "bg-blue-600",
          action: () => {
            // Trigger modal de nuevo lead
            const event = new CustomEvent("openLeadModal");
            window.dispatchEvent(event);
          },
        },
        {
          icon: Building2,
          label: `Ver ${NAV_LABELS.collaborationInventory}`,
          color: "bg-purple-600",
          action: () => navigate("/inventario-brokers"),
        },
      ];
    }

    if (role === "developer") {
      return [
        {
          icon: Building2,
          label: "Nuevo Desarrollo",
          color: "bg-accent",
          action: () => navigate("/add-development"),
        },
        {
          icon: Plus,
          label: "Nueva Propiedad",
          color: "bg-primary",
          action: () => navigate("/add-property"),
        },
        {
          icon: Users,
          label: `Ver ${NAV_LABELS.collaborationInventory}`,
          color: "bg-purple-600",
          action: () => navigate("/inventario-brokers"),
        },
      ];
    }

    if (role === "admin") {
      return [
        {
          icon: Users,
          label: "Gestionar usuarios",
          color: "bg-primary",
          action: () => navigate("/admin/users"),
        },
        {
          icon: Settings,
          label: "Configuración",
          color: "bg-blue-600",
          action: () => navigate("/admin/settings"),
        },
        {
          icon: TrendingUp,
          label: "Ver Estadísticas",
          color: "bg-emerald-600",
          action: () => window.scrollTo({ top: 0, behavior: "smooth" }),
        },
      ];
    }

    return [];
  };

  const actions = getActions();

  if (actions.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 flex flex-col gap-2 sm:gap-3">
      {actions.map((action, idx) => {
        const Icon = action.icon;
        return (
          <Button
            key={idx}
            onClick={action.action}
            className={`${action.color} text-white shadow-lg hover:shadow-xl transition-all hover:scale-105 rounded-full w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center`}
            title={action.label}
          >
            <Icon className="w-6 h-6" />
          </Button>
        );
      })}
    </div>
  );
};

export default QuickActionsMenu;
